import React, { useContext, useState, useEffect } from 'react'

import skillTree from '../../data/skilltreeview.json'
import skillInfoList from '../../data/skillInfo.json'
import * as jobID from '../../data/jobID.js'
// import * as skillID from '../../data/skillID.js'
import jobClientID from '../../data/JobIDClient.json'
// import SkillActivePassive from '../../data/skillActivePassive.json'

import './skillTree.scss'

//character context
import { CharacterContext } from '../../contexts/character'
import DisplaySkillWindow from './subComponents/DisplaySkillWindow.jsx'

export class Skill {
	constructor(sName, aName, mLv) {
		this.SkillName = sName
		this.AegisName = aName
		this.MaxLevel = mLv
		this.skillLevel = 0
	}
	increaseLevel() {
		this.skillLevel = Math.min(this.skillLevel + 1, this.MaxLevel)
	}
	decreaseLevel() {
		this.skillLevel = Math.max(this.skillLevel - 1, 0)
	}
	changeLevel(lv) {
		this.skillLevel = lv
	}
}

function SkillTree(props) {
	const { job, setSkills } = useContext(CharacterContext)

	// const [activesSkillTree, setActiveSkillTree] = useState(Number(1))
	const [allSkillTreeView, setAllSkillTreeView] = useState([[], [], []])
	const [skillTreeViewLimit, setSkillTreeViewLimit] = useState(5)

	// let allSkillTreeView = [[], [], []]

	useEffect(() => {
		getAllSkills(job, setSkills)
		job === 0x10 ? setSkillTreeViewLimit(9) : setSkillTreeViewLimit(5)
		let newSkillTreeView = [[], [], []]
		// console.log(getSkills2(job, 'Passive'))
		newSkillTreeView[0] = getSkillTreeView(
			// getSkills2(job, 'Passive'),
			getSkills(
				job &
					~jobID.THIRDMASK &
					~jobID.UPPERMASK &
					~jobID.EAJL_2 &
					~jobID.IS_MALE,
			),
		)
		newSkillTreeView[1] = getSkillTreeView(
			getSkills(job & ~jobID.THIRDMASK & ~jobID.UPPERMASK),
			// getSkills2(job, 'BuffSelf'),
		)

		//if rebirth class, add the base 2nd class skills
		if (job & jobID.UPPERMASK) {
			newSkillTreeView[1] = getSkillTreeView({
				...getSkills(job & ~jobID.THIRDMASK),
				...getSkills(job & ~jobID.THIRDMASK & ~jobID.UPPERMASK),
			})
		}

		newSkillTreeView[2] = getSkillTreeView(
			getSkills(job & ~jobID.UPPERMASK),
		)
		setAllSkillTreeView(newSkillTreeView)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [job])

	//longer skill window for doram

	// if (job === 0x10) skillTreeViewLimit = 9

	allSkillTreeView[0] = getSkillTreeView(
		getSkills(
			job &
				~jobID.THIRDMASK &
				~jobID.UPPERMASK &
				~jobID.EAJL_2 &
				~jobID.IS_MALE,
		),
	)
	allSkillTreeView[1] = getSkillTreeView(
		getSkills(job & ~jobID.THIRDMASK & ~jobID.UPPERMASK),
	)

	//if rebirth class, add the base 2nd class skills
	if (job & jobID.UPPERMASK) {
		allSkillTreeView[1] = getSkillTreeView({
			...getSkills(job & ~jobID.THIRDMASK),
			...getSkills(job & ~jobID.THIRDMASK & ~jobID.UPPERMASK),
		})
	}

	allSkillTreeView[2] = getSkillTreeView(getSkills(job & ~jobID.UPPERMASK))

	// function handleClick(e) {
	// 	setActiveSkillTree(Number(e.target.value))
	// }

	return (
		<div className={'skills ' + props.className}>
			<div className={'skillTree active'}>
				<DisplaySkillWindow
					treeView={allSkillTreeView[0]}
					treeViewLimit={skillTreeViewLimit}
					// isActive={activesSkillTree === 1}
				/>
			</div>
			{job & jobID.EAJL_2 ? (
				<div className={'skillTree active'}>
					<DisplaySkillWindow
						treeView={allSkillTreeView[1]}
						treeViewLimit={skillTreeViewLimit}
						// isActive={activesSkillTree === 2}
					/>
				</div>
			) : null}
			{job & jobID.THIRDMASK ? (
				<div className={'skillTree active'}>
					<DisplaySkillWindow
						treeView={allSkillTreeView[2]}
						treeViewLimit={skillTreeViewLimit}
						// isActive={activesSkillTree === 3}
					/>
				</div>
			) : null}
		</div>
	)
}

export default SkillTree

function getAllSkills(currentJob, apply) {
	let allskills = []
	let skills = getSkills(
		currentJob &
			~jobID.THIRDMASK &
			~jobID.UPPERMASK &
			~jobID.EAJL_2 &
			~jobID.IS_MALE,
	)
	Object.keys(skills).forEach(function (key, index) {
		// allskills.push(skills[key])
		allskills.push(
			new Skill(
				skillInfoList[skills[key]]['SkillName'],
				skillInfoList[skills[key]]['1'],
				skillInfoList[skills[key]]['MaxLv'],
			),
		)
	})
	//if not novice, set basic skill to 9
	if (currentJob > 0) allskills[0].changeLevel(allskills[0].MaxLevel)
	if (currentJob & jobID.EAJL_2) {
		skills = getSkills(currentJob & ~jobID.THIRDMASK & ~jobID.UPPERMASK)

		Object.keys(skills).forEach(function (key, index) {
			// allskills.push(skills[key])
			allskills.push(setNewSkill(skillInfoList[skills[key]]))
		})

		//if rebirth class, add the base 2nd class skills
		if (currentJob & jobID.UPPERMASK) {
			skills = getSkills(currentJob & ~jobID.THIRDMASK)
			Object.keys(skills).forEach(function (key, index) {
				// allskills.push(skills[key])
				allskills.push(setNewSkill(skillInfoList[skills[key]]))
			})
		}
	}
	if (currentJob & jobID.THIRDMASK) {
		skills = getSkills(currentJob & ~jobID.UPPERMASK)

		Object.keys(skills).forEach(function (key, index) {
			// allskills.push(skills[key])
			allskills.push(setNewSkill(skillInfoList[skills[key]]))
		})
	}
	apply(allskills)
}
function getSkills(currentJob) {
	let skills = skillTree[0]
	let formatedClassName = jobID.getFormatedClassName(currentJob)
	Object.keys(jobClientID).forEach(function (key, index) {
		if (jobClientID[key] === formatedClassName) {
			skills = skillTree[key]
			if (
				key !== '4218' &&
				!(currentJob & jobID.EAJL_2) &&
				!(currentJob & jobID.THIRDMASK)
			) {
				skills = { ...skillTree[key], ...skillTree[0] }
			}
		}
	})
	// console.log(skills)
	return skills
}
// function getSkills2(currentJob, skillType) {
// 	let skills = {}

// 	let sk_num = 0
// 	//1st class
// 	sk_num = buildSkillList(
// 		currentJob & ~jobID.EAJL_2 & ~jobID.EAJL_UPPER & ~jobID.EAJL_THIRD,
// 		skills,
// 		skillType,
// 		sk_num,
// 	)

// 	if (jobID.isSecondJob(currentJob)) {
// 		sk_num = buildSkillList(
// 			currentJob & ~jobID.EAJL_UPPER & ~jobID.EAJL_THIRD,
// 			skills,
// 			skillType,
// 			sk_num,
// 		)
// 	}
// 	//rebirth
// 	if (jobID.isRebirth(currentJob)) {
// 		sk_num = buildSkillList(
// 			currentJob & ~jobID.EAJL_THIRD,
// 			skills,
// 			skillType,
// 			sk_num,
// 		)
// 	}
// 	//3rd class
// 	if (jobID.isThirdJob(currentJob)) {
// 		buildSkillList(
// 			currentJob & ~jobID.EAJL_UPPER,
// 			skills,
// 			skillType,
// 			sk_num,
// 		)
// 	}

// 	// console.log(skills)
// 	return skills
// }
// function buildSkillList(currentJob, skills, skillType, lastSkillPosition) {
// 	let tmp_sk_num = 0
// 	SkillActivePassive[jobID.getClassName(currentJob)][skillType].map(
// 		(sk_, index) => {
// 			skills[lastSkillPosition + index] = skillID[sk_]
// 			return tmp_sk_num++
// 		},
// 	)
// 	return tmp_sk_num + lastSkillPosition
// }
function getSkillTreeView(skills) {
	let skillTreeView = [
		new Array(7).fill(new Skill('', '', 0)),
		new Array(7).fill(new Skill('', '', 0)),
		new Array(7).fill(new Skill('', '', 0)),
		new Array(7).fill(new Skill('', '', 0)),
		new Array(7).fill(new Skill('', '', 0)),
		new Array(7).fill(new Skill('', '', 0)),
	]
	Object.keys(skills).forEach(function (key, index) {
		//add new line if the skill tree is longer (for doram)
		if (Math.floor(key / 7) + 1 > skillTreeView.length)
			skillTreeView.push(new Array(7).fill(new Skill('', '', 0)))
		let col = Math.floor(key / 7)
		let row = Math.floor(key % 7)
		let newSkill = setNewSkill(skillInfoList[skills[key]])
		// let newSkill = new Skill(
		// 	skillInfoList[skills[key]]
		// 		? skillInfoList[skills[key]]['SkillName']
		// 		: 'Unknown',
		// 	skillInfoList[skills[key]]
		// 		? skillInfoList[skills[key]]['1']
		// 		: 'Unknown',
		// 	skillInfoList[skills[key]] ? skillInfoList[skills[key]]['MaxLv'] : 1
		// )

		skillTreeView[col][row] = newSkill
	})
	return skillTreeView
}
function setNewSkill(skillInfo) {
	return new Skill(
		skillInfo ? skillInfo['SkillName'] : 'Unknown',
		skillInfo ? skillInfo['1'] : 'Unknown',
		skillInfo ? skillInfo['MaxLv'] : 1,
	)
}
